"use client";

import { cn } from "@/lib/utils";

export function FormField({ type = "text", name, placeholder, value, onChange, className, rows }) {
  const baseStyle = {
    padding: "8px 14px",
    background: "rgba(255, 255, 255, 0.05)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    borderRadius: "5px",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "-0.002em",
    color: "white",
  };

  const baseClasses = cn(
    "w-full placeholder:text-white/60 focus:outline-none focus:border-white/40 transition-colors",
    className
  );

  if (type === "textarea") {
    return (
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows || 4}
        className={cn(baseClasses, "resize-none")}
        style={baseStyle}
      />
    );
  }

  return (
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={baseClasses}
      style={{ ...baseStyle, height: "36px" }}
    />
  );
}
